import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { forWhomItems } from '../data/content';
export function ForWhom() {
  return <section className="w-full bg-sand py-16 sm:py-24" aria-labelledby="para-quien" data-id="element-47" data-mp="33ix4o1ouxmba">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-48" data-mp="2yjklps13wzdz">
        <div className="flex flex-col items-center" data-id="element-49" data-mp="2yl40tfb114e6">
          <SectionHeading eyebrow="Para quién es" title="Este programa es para vos si..." subtitle="¿Te sentís identificada con alguna de estas frases?" intro="No necesitás haber entrenado nunca. Este programa fue creado exactamente para mujeres como vos." data-id="element-50" data-mp="3w63axrnnz" />
        </div>

        <ul className="mx-auto mt-12 grid max-w-4xl gap-4 sm:grid-cols-2" data-id="element-51" data-mp="3hhdei1i0nsxn">
          {forWhomItems.map((item, index) => <motion.li key={item} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.45,
          ease: 'easeOut',
          delay: index * 0.06
        }} className="flex items-start gap-4 rounded-3xl border border-linen bg-cream p-6" data-id="element-52" data-mp="e0wu6y0g50vu" data-mpi={index}>
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sage-light text-sage-dark" aria-hidden="true" data-id="element-53" data-mp="1fctwammwc5ld">
                <CheckIcon className="h-5 w-5" strokeWidth={2.5} data-id="element-54" data-mp="15itjdyldhw23" />
              </span>
              <p className="text-lg leading-relaxed text-ink" data-id="element-55" data-mp="1adgyx7yefg4j">{item}</p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}